module.exports = "/assets/bc0650366283d117122ab161b6728b48.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/7B.png
// module id = 1105
// module chunks = 0